import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ExchangeRequest,
  ManualConnectRequest,
  UpdateWhatsappSettingsRequest,
  WhatsappAccountResponse,
  WhatsappSettingsResponse,
} from '../models/whatsapp.model';

@Injectable({ providedIn: 'root' })
export class WhatsappAccountApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/whatsapp`;

  exchange(req: ExchangeRequest): Observable<WhatsappAccountResponse> {
    return this.http.post<WhatsappAccountResponse>(
      `${this.base}/onboarding/exchange`,
      req
    );
  }

  /** Conexión manual para pruebas, sin Embedded Signup. Sólo admin. */
  connectManually(req: ManualConnectRequest): Observable<WhatsappAccountResponse> {
    return this.http.post<WhatsappAccountResponse>(
      `${this.base}/onboarding/manual`,
      req
    );
  }

  getAccount(): Observable<WhatsappAccountResponse> {
    return this.http.get<WhatsappAccountResponse>(`${this.base}/account`);
  }

  disconnect(): Observable<void> {
    return this.http.delete<void>(`${this.base}/account`);
  }

  /**
   * Ajustes del canal. No devuelve 404 sin cuenta conectada: responde 200 con
   * `connected: false`, así que la pantalla no necesita tratar ese caso como error.
   *
   * El negocio sale del JWT: este endpoint NO lleva `businessId` por query.
   */
  getSettings(): Observable<WhatsappSettingsResponse> {
    return this.http.get<WhatsappSettingsResponse>(`${this.base}/settings`);
  }

  /** Guardar los ajustes exige rol Admin o Super Admin además del permiso whatsapp:EDIT. */
  updateSettings(req: UpdateWhatsappSettingsRequest): Observable<WhatsappSettingsResponse> {
    return this.http.put<WhatsappSettingsResponse>(`${this.base}/settings`, req);
  }
}
